<nz-modal #modalRef nzSize [(nzVisible)]="isVisible"
  [nzTitle]="(isEdit ? 'Edit' : 'Add') + ' Nutrition Intake' | translate" (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null" class="custom-modal-class">
  <ng-container *nzModalContent>
    <form [formGroup]="nutritionIntakeForm" (ngSubmit)="submitForm()" [ngClass]="{
        'nutrition-intake-submitted': nutritionIntakeSubmitted,
        'nutritionIntake-not-submitted': !nutritionIntakeSubmitted
      }">
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Onset Date & Time" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70" fxLayoutAlign="start center">
          <input class="inputs nutritionIntake" type="datetime-local" [placeholder]="'Date' | translate"
            formControlName="dateValue" [max]="getCurrentDateTime()" />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Food Type" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <nz-select class="inputs nutritionIntake" nzShowSearch nzAllowClear [nzPlaceHolder]="'Food Type' | translate"
            formControlName="foodTypeValue" [nzLoading]="isDropdownLoading">
            @for (eo of dropdown.foodTypes; track eo) {
            <nz-option [nzLabel]="eo.display" [nzValue]="eo.id"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Portion Size (gr)" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70" fxLayoutAlign="start center">
          <input class="inputs nutritionIntake" type="number" [placeholder]="'Portion Size (gr)' | translate"
            formControlName="portionSizeValue" min="0" />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Portion Eaten (%)" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70" fxLayoutAlign="start center">
          <!-- <input class="inputs nutritionIntake" type="number" [placeholder]="'Portion Eaten (%)' | translate"
              formControlName="portionEatenPercentageValue" /> -->

          <nz-slider formControlName="portionEatenPercentageValue" [nzStep]="5" [nzMin]="0" [nzMax]="100"
            [nzMarks]="nzMarks" class="inputs nutritionIntake" [nzReverse]="true" [nzTipFormatter]="formatPercentage">
          </nz-slider>
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Description" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70" fxLayoutAlign="start center">
          <textarea class="nutritionIntake text-area" rows="2" nz-input [placeholder]="'Description ...' | translate"
            formControlName="descriptionValue" class="neck text-area"></textarea>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isLoading" [disabled]="isLoading">
          {{ "Save" | translate }}
        </button>
        <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleCancel()" [disabled]="isLoading">
          {{ "Cancel" | translate }}
        </button>
      </div>
    </form>
  </ng-container>
  <ng-template>
    <button type="submit">{{ "Save" | translate }}</button>
  </ng-template>
</nz-modal>